import { render, staticRenderFns } from "./auth.vue?vue&type=template&id=6d947ed0&scoped=true"
import script from "./auth.vue?vue&type=script&lang=js"
export * from "./auth.vue?vue&type=script&lang=js"
import style0 from "./auth.vue?vue&type=style&index=0&id=6d947ed0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d947ed0",
  null
  
)

export default component.exports